const sortUniqExtract = (data, column) => (
  data.reduce((acc, curr)=>{
    if (! acc.includes(curr[column])) {
      acc.push(curr[column])
    }
    return acc
  }, [])
)

//Convert to percent of Object with value 
const toPercent = (version)=>{
  let sum = Object.values(version).reduce((a,b)=>(a+b), 0)
  return Object.entries(version).reduce((p, [k, v]) => ({ ...p, [k]: sum == 0 ? 0 : 100 * Number(v)/sum }), {})
}

const objectValueMap = (obj, callback) => (
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, callback(v)]))
)

export const globalLocationStatusDataToChartData = (data) => {
  const major_os_versions = sortUniqExtract(data ,"major_os_version").sort((a, b) => (a - b))
  const status = sortUniqExtract(data, "location_status").sort((a, b) => toString(a).localeCompare(toString(b)))
  const perVersionPerStatus = data.reduce((acc, curr)=> {
    if(! acc[curr.major_os_version]) {
      acc[curr.major_os_version] = status.length > 0 ? Object.assign(...status.map((k) => ({ [k]: 0 }))) : {};
    }
    acc[curr.major_os_version][curr.location_status] = curr.active_devices
    return acc
  }, {})
  const percent = objectValueMap(perVersionPerStatus, toPercent)
  const series = status.map((statu)=>{
    return {
      name: statu,
      data: major_os_versions.map((version)=> percent[version][statu] )
    }
  })
  return {
    "categories": major_os_versions,
    "series": series
  }
}

export const locationStatusDataToChartData = (os) => (data) => {
  const osData = data.filter( (x)=>(x.os === os) )
  return globalLocationStatusDataToChartData(osData)
}